import { useState } from "react";

import { Popover } from "@mantine/core";
import { Button, DropdownMenu, DropdownRow } from "@onengine/component-library";
import { IconChevronDown, IconLayoutColumns, IconLayoutGrid } from "@tabler/icons-react";

import { useFileManagerHeaderCompact } from "@/components/core/FileManager";

const DROPDOWN_STYLE = {
  border: "none",
  boxShadow: "none",
  background: "transparent",
  width: "fit-content",
};

interface FileViewDropdownProps {
  viewMode: "grid" | "columns";
  onViewChange: (mode: "grid" | "columns") => void;
}

export function FileViewDropdown({ viewMode, onViewChange }: FileViewDropdownProps) {
  const [opened, setOpened] = useState(false);
  // Driven by the header's own width: the viewport says nothing useful here,
  // since the sidebars decide how much room the toolbar actually gets.
  const isCompact = useFileManagerHeaderCompact();

  const label = viewMode === "grid" ? "Grid" : "Columns";
  const Icon = viewMode === "grid" ? IconLayoutGrid : IconLayoutColumns;

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end" offset={4} zIndex={100}>
      <Popover.Target>
        {isCompact ? (
          <Button
            type="icon"
            variant="neutral-secondary"
            iconLeft={<Icon size={16} />}
            onClick={() => setOpened((o) => !o)}
            htmlAttributes={{ "aria-label": `View: ${label}` }}
          />
        ) : (
          <Button
            type="button"
            variant="neutral-secondary"
            iconLeft={<Icon size={16} />}
            iconRight={<IconChevronDown size={16} />}
            onClick={() => setOpened((o) => !o)}
          >
            {label}
          </Button>
        )}
      </Popover.Target>
      <Popover.Dropdown style={DROPDOWN_STYLE} p={0}>
        <DropdownMenu width={160} scrollable={false}>
          <DropdownRow
            title="Grid"
            leftSection={<IconLayoutGrid size={20} />}
            active={viewMode === "grid"}
            onClickCapture={() => setOpened(false)}
            onClick={() => onViewChange("grid")}
          />
          <DropdownRow
            title="Columns"
            leftSection={<IconLayoutColumns size={20} />}
            active={viewMode === "columns"}
            onClickCapture={() => setOpened(false)}
            onClick={() => onViewChange("columns")}
          />
        </DropdownMenu>
      </Popover.Dropdown>
    </Popover>
  );
}
